import { render, staticRenderFns } from "./WalletCouponCard.vue?vue&type=template&id=d537e5da&scoped=true"
import script from "./WalletCouponCard.vue?vue&type=script&lang=js"
export * from "./WalletCouponCard.vue?vue&type=script&lang=js"
import style0 from "./WalletCouponCard.vue?vue&type=style&index=0&id=d537e5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d537e5da",
  null
  
)

export default component.exports